import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6bc74f65&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&id=6bc74f65&prod&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=6bc74f65&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc74f65",
  null
  
)

export default component.exports